import clsx from 'clsx';
import React, { useEffect, useRef } from 'react';
import './style.css';

interface VideoProps {
  autoPlay?: boolean;
  className?: string;
  muted?: boolean;
  playsinline?: boolean;
  style?: React.CSSProperties;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  videoTrack: any;
}

const Video: React.FC<VideoProps> = ({
  autoPlay = true,
  className = '',
  muted = true,
  playsinline = true,
  style = {},
  videoTrack,
}) => {
  const videoElement = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    const videoNode = videoElement.current;
    if (videoNode && videoTrack) {
      videoTrack.attach(videoNode).catch((error: Error) => {
        console.error('Error attaching video track:', error);
      });
    }

    return () => {
      if (videoNode && videoTrack) {
        videoTrack.detach(videoNode);
      }
    };
  }, [videoTrack]);

  return (
    <video
      autoPlay={autoPlay}
      className={clsx('cometchat-calls-video', className)}
      muted={muted}
      playsInline={playsinline}
      ref={videoElement}
      style={style}
    />
  );
};

export default Video;
